import { default as React } from 'react'
import { DashboardLayout } from '../../../../components/DashboardLayout/DashboardLayout'
import { Header } from '../../../../components/Header/Header'
import { LoadingFormPage } from '../../../../components/LoadingFormPage/LoadingFormPage'
import { Title } from '../../../../components/Title/Title'
import { useAuth } from '../../../../hooks/useAuth'
import { ImportWizard } from './components/ImportWizard'
import { useHandleImport } from './hooks/useHandleImport'

export const ProgramImport = () => {
  const { program, isSwitching } = useAuth()
  const { handleParseFile, handleBulkCreate } = useHandleImport({
    programId: program?.id,
  })

  if (!program || isSwitching) {
    return (
      <DashboardLayout>
        <Title value="Loading..." />
        <LoadingFormPage />
      </DashboardLayout>
    )
  }

  return (
    <DashboardLayout>
      <Title value="Import" />
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <Header subtitle="Data" title="Import" breadcrumbs={[{ label: 'Import data' }]} />
          </div>
        </div>
        <div className="row justify-content-center mt-md-2 mt-3 mb-3">
          <div className="col-12 col-lg-10">
            <ImportWizard
              program={program}
              onUploadFile={handleParseFile}
              onSubmit={handleBulkCreate}
            />
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
